import { Nav, Footer } from "../components/Nav";

import { useEffect, useState } from "react";
// import arrow from "../images/arrow.svg";
import HoneyBuddyThumbnail from "../images/HoneyBuddy/HoneyBuddy Thumbnail.jpg";
// import logoIcon from "../logo-icon.svg";
import SMTThumbnail from "../images/SMT/SMT Thumbnail.png";
// import CDMThumbnail from "../images/CDM/CDM Thumbnail.png";
import PursuantThumbnail from "../images/Pursuant/Pursuant Thumbnail.png";
import CakeryThumbnail from "../images/Cakery/Cakery Thumbnail.png";
// import TaskBuddyThumbnail from "../images/TaskBuddy/TaskBuddy Thumbnail.png";
// import CakeryThumbnail from "../images/Cakery/Cakery Thumbnail.png";
// import MemologThumbnail from "../images/Memolog/Memolog Thumbnail.png";
// import WebcrackThumbnail from "../images/WebCrack/Webcrack Thumbnail.png";
// import ACMWThumbnail from "../images/ACMW/ACM-W Thumbnail.png";
// import { MeetMe } from "../components/ProjectDetails";
import { LargeCard } from "../components/Cards";
import Constellation from "../components/Constellation";

export default function Portfolio() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const fullTitle = `<h1> MANDY LIN </h1>\n\n<p>UX Designer at the intersection of design and development.</p>`;
  const nameOnly = "MANDY LIN";
  const [displayed, setDisplayed] = useState("");
  const [phase, setPhase] = useState("typing"); // typing, pause, nameOnly

  useEffect(() => {
    let timeout;
    if (phase === "typing") {
      if (displayed.length < fullTitle.length) {
        timeout = setTimeout(() => {
          setDisplayed(fullTitle.slice(0, displayed.length + 1));
        }, 50);
      } else {
        timeout = setTimeout(() => setPhase("pause"), 60);
      }
    } else if (phase === "pause") {
      timeout = setTimeout(() => {
        setDisplayed(nameOnly);
        setPhase("nameOnly");
      }, 800);
    }
    return () => clearTimeout(timeout);
  }, [displayed, phase, fullTitle, nameOnly]);

  return (
    <>
      <Nav color={phase === "typing" || phase === "pause" ? "gray" : "white"} />
      <main className="main-container">
        {/*Intro Section*/}
        <section
          id="intro-section"
          className={`black-bg ${phase === "nameOnly" ? "intro-complete" : ""}`}
        >
          <Constellation />
          <div className="intro-container white-text">
            <h1
              className={
                phase === "typing" || phase === "pause"
                  ? "gray-text typing-title"
                  : "white-text"
              }
            >
              {displayed}
              <span
                className={
                  "blinking-cursor " +
                  (phase === "typing" || phase === "pause"
                    ? "gray-text "
                    : "hide-cursor")
                }
              >
                |
              </span>
            </h1>
            {phase === "nameOnly" && (
              <>
                <p className="slogan">
                  UX DESIGNER AT THE INTERSECTION OF DESIGN AND DEVELOPMENT
                </p>
                <br />

                <p style={{ fontWeight: "var(--semiBold-fw)" }}>Currently: </p>
                <p style={{ marginBottom: "0.5rem" }}>MS-HCI @ Georgia Tech</p>

                <p style={{ fontWeight: "var(--semiBold-fw)" }}>Previously: </p>

                <p>UI Engineering Intern @ Trimble (Summer 2025)</p>
                <p>CS @ Santa Clara University (2021-2024)</p>
              </>
            )}
          </div>
        </section>

        {/*Projects Section*/}
        <section id="projects" className="white-bg">
          {/* <h1 id="projects-title" className="black-text">
            PROJECTS
          </h1> */}
          <div id="project-catalog">
            {/*HoneyBuddy*/}
            <LargeCard
              img={HoneyBuddyThumbnail}
              title="01 HoneyBuddy"
              description="UX Design (2025) | Design-a-thon Project"
              link="/honeybuddy"
            />
            {/*SMT*/}
            <LargeCard
              img={SMTThumbnail}
              title="02 Who's on First?"
              description="Front-end Development + UI Design (2024)"
              link="/smt"
            />
            {/*Children's Discovery Museum*/}
            {/* <LargeCard
              img={CDMThumbnail}
              title="Children’s Discovery Museum"
              description="UI Redesign (2023)"
              link="/cdm"
            /> */}

            {/*Cakery*/}
            <LargeCard
              img={CakeryThumbnail}
              title="03 Cakery"
              description="Logo and Brand Design (2023)"
              link="/cakery"
            />
            {/*Pursuant Health*/}
            <LargeCard
              img={PursuantThumbnail}
              title="04 COMING SOON: Health Kiosk Login System"
              description="UX Design and Research (2025) | Sponsored Project"
              link="#"
              comingSoon={true}
            />
            {/*TaskBuddy*/}
            {/*
            <LargeCard
              img={TaskBuddyThumbnail}
              title="TaskBuddy"
              subtitle="Full-stack Development, Database"
              description="Boost your productivity with our web-based task management app!"
              link="/honeybuddy"
            />
            */}
          </div>
        </section>
      </main>
      {/* <MeetMe /> */}
      <Footer color="black" />
    </>
  );
}
